import api from '../api';
import { CreateAgendamentoDto, AgendamentoResponse, ApiError } from './types';

export class AgendamentoService {
  /**
   * Cria um novo agendamento na landing page
   * @param agendamentoData - Dados do agendamento
   * @returns Promise com resposta do agendamento criado
   */
  static async createAgendamento(agendamentoData: CreateAgendamentoDto): Promise<AgendamentoResponse[]> {
    try {
      const response = await api.post<AgendamentoResponse[]>('agendamentos', agendamentoData);
      return response.data;
    } catch (error: any) {
      throw this.handleApiError(error);
    }
  }

  /**
   * Lista todos os agendamentos da sessão atual
   * @returns Promise com array de agendamentos
   */
  static async getAgendamentos(): Promise<AgendamentoResponse[]> {
    try {
      const response = await api.get<AgendamentoResponse[]>('agendamentos');
      return response.data;
    } catch (error: any) {
      throw this.handleApiError(error);
    }
  }

  /**
   * Trata erros da API
   */
  private static handleApiError(error: any): ApiError {
    if (error.response?.data) {
      return {
        message: error.response.data.message || 'Erro na requisição',
        statusCode: error.response.status,
        error: error.response.data.error,
      };
    }

    return {
      message: 'Erro de conexão com o servidor',
      statusCode: 500,
      error: 'Network Error',
    };
  }
}
